export default __webpack_public_path__ + "static/media/language-de.193acc7f.svg";